import { css } from 'styled-components'

const printStyles = css`
  @media print {
    #hs-app {
      position: static;

      .simplebar-content-wrapper {
        padding-left: 0px !important;
      }

      .simplebar-placeholder,
      .simplebar-content-wrapper,
      .simplebar-mask,
      .simplebar-offset {
        overflow: visible !important;
        position: static !important;
        height: auto !important;
      }

      // show full year and assignee if user is in print mode
      [data-printformattedtime] {
        visibility: hidden;

        time {
          display: none;
        }

        &:after {
          content: attr(data-printformattedtime);
          visibility: visible;
          display: inline;
          position: relative;
        }
      }

      // Add specific handling for anchor tags with the attribute
      a[data-printformattedtime] {
        position: relative;
        display: inline-block;
      }

      // Sidenav
      .c-Accordion__Section {
        box-shadow: none;
        border-bottom: 1px solid #c2cace;
      }

      #no-apps {
        padding: 30px 15px;
      }
    }
  }
`

export default printStyles
